import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth.service";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {
  public poliza: number;

  passwordConfirm: boolean;
  mensajeError: any;
  email: string;
  errorMessage: string;
  waitingForApi: boolean;
  show: boolean = false;
  constructor(private auth: AuthService) {
    this.mensajeError = "";
    this.passwordConfirm = false;
    this.poliza = 1;
    this.waitingForApi = false;
  }

  ngOnInit(): void {}
  crearUsuario(registerForm) {
    this.email = registerForm.value.email;
    let stringEmail = this.email.split("@");
    let direccion = stringEmail[1];
    let correo = stringEmail[0];
    let letras = correo.split("", 2);

    this.email = letras[0] + letras[1] + "******@" + direccion;
    console.log(this.email);

    this.waitingForApi = true;
    this.auth.registerUser(registerForm.value).subscribe(
      (response) => {
        this.waitingForApi = false;
        console.log(response);
        this.poliza = 2;
      },
      (error) => {
        this.waitingForApi = false;
        console.log(error);
        if (error.error.message) {
          this.errorMessage = error.error.message;
        }
      }
    );
  }

  confirmPassword(registerForm) {
    if (registerForm.value.password1 == registerForm.value.password2) {
      this.passwordConfirm = true;
      this.mensajeError = "";
    } else {
      this.mensajeError = "Las contraseña debe coincidir";
    }
  }
  clearErrors(registerForm) {
    if (registerForm.value.password1 == registerForm.value.password2) {
      this.passwordConfirm = true;
    }
    this.mensajeError = "";
  }

  switchPass() {
    this.show = !this.show;
    console.log(this.show);
  }
}
